import Benchmarking from "@/services/benchmarking";

const initialState = {
  inital: true,
  fetchOwnScore: true,
  loading: true,
  user: null,
  currentFilter: {
    year: undefined,
    list: undefined,
    state: undefined,
    affiliation: undefined,
  },
  filters: {
    lists: {},
    affiliations: [],
    states: [],
  },
  own_scores: {
    treatment: 0,
    reputation: 0,
    science: 0,
    qualification: 0,
    service: 0,
  },
  scores: {
    treatment: [],
    reputation: [],
    science: [],
    qualification: [],
    service: [],
  },
};
export const benchmarking = {
  namespaced: true,
  state: initialState,
  getters: {
    lists: (state) => {
      if (state.currentFilter.year !== undefined) {
        return state.filters.lists[state.currentFilter.year].map((a) => ({
          value: a.id,
          label: a.name,
        }));
      }

      let lists = [];
      Object.keys(state.filters.lists).forEach((list) => {
        lists = [
          ...state.filters.lists[list].map((a) => ({
            value: a.id,
            label: a.name,
          })),
        ];
      });
      return lists;
    },
    years: (state) =>
      Object.keys(state.filters.lists).map((y) => ({
        value: parseInt(y),
        label: `FOCUS-Ärzteliste ${y}`,
      })),
    states: (state) => [
      { value: null, label: "Alle" },
      ...state.filters.states,
    ],
    affilations: (state) => [
      { value: null, label: "Alle" },
      ...state.filters.affiliations.map((a) => ({
        value: a,
        label:
          a === "clinic"
            ? "Klinik"
            : a === "practice"
            ? "Praxis"
            : a === "reha"
            ? "Reha"
            : a === "mvz"
            ? "MVZ"
            : "Krankenhaus",
      })),
    ],
    score: (state) => {
      return (key, sub) => {
        if (
          state.scores[key] &&
          state.scores[key][sub] &&
          state.scores[key][sub].data.length > 0
        ) {
          return state.scores[key][sub];
        }
        return {
          data: [],
          total: 0,
        };
      };
    },
    ownScore: (state) => {
      return (key) => {
        if (state.own_scores[key]) {
          return state.own_scores[key];
        }
        return 0;
      };
    },
    displayScore: (state) => {
      return state.own_scores["ranked"] || false;
    },
    totalScore: (state, getters) => {
      if (state.loading) {
        return 0;
      }
      const cutoff = getters.cutoff;
      const score = (state.own_scores["total"] || 0) * 100;

      if (score >= cutoff) {
        return 100;
      }

      return Math.round((score / cutoff) * 100);
    },
    cutoff: (state) => {
      if (
        !state.currentFilter.list ||
        !state.currentFilter.year ||
        !state.filters.lists[state.currentFilter.year]
      ) {
        return 0;
      }

      const award = state.filters.lists[state.currentFilter.year].find(
        (a) => a.id === state.currentFilter.list
      );

      if (!award) {
        return 0;
      }

      return Math.round(award.cutoff * 100);
    },
  },
  actions: {
    filters(s) {
      const commit = s.commit;
      if (this.filtersRequest) {
        return this.filtersRequest;
      }

      this.filtersRequest = Benchmarking.filters(
        s.state.currentFilter,
        s.state.user
      )
        .then((response) => {
          if (response.data) {
            commit("filtersSuccess", response.data);
            this.filtersRequest = undefined;
            return Promise.resolve(response.data);
          }
          commit("filtersFailure");
          this.filtersRequest = undefined;
          return Promise.reject(response);
        })
        .catch((error) => {
          commit("filtersFailure");
          this.filtersRequest = undefined;
          return Promise.reject(error);
        });
      return this.filtersRequest;
    },
    scores(s) {
      const commit = s.commit;
      // we only search when there is a list filter
      if (!s.state.currentFilter.list) {
        return Promise.resolve();
      }
      if (this.scoresRequest) {
        return this.scoresRequest;
      }

      this.scoresRequest = Benchmarking.scores(
        s.state.currentFilter,
        s.state.user,
        s.state.inital || s.state.fetchOwnScore
      ).then(
        (response) => {
          commit("scoresSuccess", response);
          this.scoresRequest = undefined;
          return Promise.resolve(response);
        },
        (error) => {
          commit("scoresFailure");
          this.scoresRequest = undefined;
          return Promise.reject(error);
        }
      );

      return this.scoresRequest;
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setInitial(state) {
      state.inital = true;
      state.fetchOwnScore = true;
    },

    filtersSuccess(state, filters) {
      if (state.inital) {
        state.filters = filters;
        const currentYear = new Date().getFullYear();
        if (Object.keys(state.filters.lists).includes(currentYear)) {
          state.currentFilter.year = currentYear;
        } else {
          //simply select 1st year
          state.currentFilter.year = parseInt(
            Object.keys(state.filters.lists)[0]
          );
        }
        //simply preselect the first list
        state.currentFilter.list = parseInt(
          state.filters.lists[Object.keys(state.filters.lists)[0]][0]["id"]
        );
        state.currentFilter.affiliation = undefined;
        state.currentFilter.state = undefined;
        state.inital = false;
      }
    },
    filtersFailure(state) {
      state.filters = initialState.filters;
      state.loading = false;
    },
    scoresSuccess(state, scores) {
      if (scores[0]) {
        state.scores = scores[0].data;
      }
      if (scores[1]) {
        state.own_scores = scores[1].data;
      }
      state.inital = false;
      state.loading = false;
    },
    scoresFailure(state) {
      state.scores = initialState.scores;
    },
    filterYear(state, year) {
      state.currentFilter.year = parseInt(year);
      state.fetchOwnScore = true;
      state.loading = true;
    },
    filterAffiliation(state, affilation) {
      if (affilation) {
        state.currentFilter.state = undefined;
      }
      state.currentFilter.affiliation = affilation;
      state.fetchOwnScore = false;
      state.loading = true;
    },
    filterState(state, geoState) {
      if (geoState) {
        state.currentFilter.affiliation = undefined;
      }
      state.currentFilter.state = geoState;
      state.fetchOwnScore = false;
      state.loading = true;
    },
    filterList(state, list) {
      state.currentFilter.list = parseInt(list);
      state.fetchOwnScore = true;
      state.loading = true;
    },
  },
};
